import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addTemplates,
  deleteTemplates,
  getTemplates,
  updateTemplates,
} from "store/services/dataManagement/messageTemplate";
import { uploadFile } from "store/services/utilities";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

export const GetAllTemplates = createAsyncThunk(
  "templates/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getTemplates(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const AddTemplatesAction = createAsyncThunk(
  "templates/add",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      let { image, onSuccess, onError, ...rest } = payload;

      if (image instanceof File) {
        const uploadFilesResponse = await uploadFile({
          file: image,
          uploadFor: "template",
        });

        if (uploadFilesResponse.status === 0) {
          dispatch(
            openToast({
              type: "error",
              message: uploadFilesResponse.message,
            }),
          );

          return rejectWithValue(uploadFilesResponse);
        }

        rest.image = uploadFilesResponse.response?.[0]?.url || "";
      }

      const res = await addTemplates(rest);

      if (res.status === 1) {
        dispatch(closeAdminModal());
        dispatch(GetAllTemplates({ type: rest.type }));

        if (onSuccess) onSuccess();

        return fulfillWithValue(res);
      }

      if (onError) onError();

      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(res?.statusCode),
        }),
      );

      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error.response.data.statusCode)
            : error.message,
        }),
      );

      return rejectWithValue(error);
    }
  },
);

export const UpdateTemplatesAction = createAsyncThunk(
  "templates/update",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      let { image, onSuccess, onError, ...rest } = payload;

      if (image instanceof File) {
        const uploadFilesResponse = await uploadFile({
          file: image,
          uploadFor: "template",
        });

        if (uploadFilesResponse.status === 0) {
          dispatch(
            openToast({
              type: "error",
              message: uploadFilesResponse.message,
            }),
          );

          return rejectWithValue(uploadFilesResponse);
        }

        rest.image = uploadFilesResponse.response?.[0]?.url || "";
      } else if (image === null) {
        // remove image
        rest.image = "";
      } else {
        // keep existing image
        rest.image = image;
      }

      const res = await updateTemplates(rest);

      if (res.status === 1) {
        dispatch(closeAdminModal());
        dispatch(GetAllTemplates({ type: rest.type }));

        if (onSuccess) onSuccess();

        return fulfillWithValue(res);
      }

      if (onError) onError();

      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(res?.statusCode),
        }),
      );

      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error.response.data.statusCode)
            : error.message,
        }),
      );

      return rejectWithValue(error);
    }
  },
);

export const DeleteTemplatesAction = createAsyncThunk(
  "templates/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, ...rest } = payload;
      const res = await deleteTemplates(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        dispatch(closeAdminModal());
        dispatch(GetAllTemplates({ type: rest.type }));
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
